import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'src/app/models/user.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { RapidGlobalInfo } from 'src/app/models/user.model';
import { SiteInductionInfo } from 'src/app/models/user.model';
import { SiteService } from 'src/app/services/site/site.service';
import { Site } from 'src/app/models/site.model';
import { DatePipe } from '@angular/common';
import { InductionConfigDetail } from 'src/app/models/inductionconfigdetail.model';
import { environment } from 'src/environments/environment';
import { FileStorageService } from 'src/app/services/filestorage/filestorage.service';
import { ComplianceCheckAnswerModel } from '@app/models/inductionqna.model';
import { UserService } from '@app/services/user/user.service';
import { ConfigurationService } from '@app/services/configuration/configuration.service';
import { CityComplianceStatus, CompanyType, DefaultCompanyType, DisplayedComplianceStatus, SiteInductionStatus } from 'src/app/shared/enums';
import { LocalizationService } from '../internationalization/localization.service';
import { JobService } from '@app/services/job/job.service';
import { CityCompliance } from '@app/models/compliance.model';
import { ClosedownService } from '@app/services/closedown/closedown.service';
import { MatDialog } from '@angular/material/dialog';
import { SiteInductionAddEditComponent } from '../site-induction-add-edit/site-induction-add-edit.component';

@Component({
    selector: 'app-site-compliance-check',
    templateUrl: './site-compliance-check.component.html',
    styleUrls: ['./site-compliance-check.component.scss'],
    standalone: false
})
export class SiteComplianceCheckComponent implements OnInit {
  readonly SiteInductionStatus = SiteInductionStatus;
  public siteComplianceCheckFormGroup!: UntypedFormGroup;
  currentUser: User | undefined;
  phoneNumber: string | undefined;
  profileImgLink: string | undefined;
  public rapidGlobalInfoList: RapidGlobalInfo[] = [];
  public siteInductionInfoList: SiteInductionInfo[] = [];
  withJob = false;
  fullname: string | undefined;
  currentSite: Site | undefined;
  public rapidGlobalInfo: RapidGlobalInfo[] = [];
  public siteInductionInfo: SiteInductionInfo[] = [];
  selectedRapidGlobalId: string | undefined;
  selectedRapidGlobalInfo: RapidGlobalInfo | undefined;;
  selectedSiteInductionInfo: SiteInductionInfo | undefined;;
  siteComplianceCheckConfig: InductionConfigDetail | undefined;
  @Input() inductionConfigDetail: any = '';
  profileInductionRequired: boolean = false;
  profileRapidGlobalRequired: boolean = false;
  fastLinkResourceId: string = '';
  hasActiveBrandInductionConfig: boolean = false;

  get visitorCardAvailable(): boolean {
    return this.profileInductionRequired && this.hasActiveBrandInductionConfig;
  }

  statusCompliant = this._localizationService.translate(DisplayedComplianceStatus.statusCompliant);
  statusNotCompliant = this._localizationService.translate(DisplayedComplianceStatus.statusNotCompliant);
  statusNotApplicable = this._localizationService.translate(DisplayedComplianceStatus.statusNotApplicable);
  complianceErrorMessage: string = "";
  notComplianceIcon: string = this._localizationService.translate('site_compliance_status_error_message_icon');
  defaultNoCompanySpecified: string = DefaultCompanyType.NO_COMPANY_SPECIFIED;
  defaultCityFMCompanyName: string = DefaultCompanyType.CITYFM;
  defaultCityFMAsiaCompanyName: string = DefaultCompanyType.CITYFMASIA;
  defaultCompanyName: string = this.defaultNoCompanySpecified;
  outputCityCompliance: CityCompliance = {
    errorMessage: '',
    resourceId: '',
    siteId: '',
    cityComplianceStatus: CityComplianceStatus.NOTAPPLICABLE
  };

  @Output() showComplianceError = new EventEmitter<CityCompliance>();

  constructor(private _authService: AuthService,
    private _siteService: SiteService,
    public _router: Router,
    private formBuilder: UntypedFormBuilder,
    public datepipe: DatePipe,
    private _fileStorageService: FileStorageService,
    private _userService: UserService,
    private _configurationService: ConfigurationService,
    private _localizationService: LocalizationService,
    private _jobService: JobService,
    private _closedownService: ClosedownService,
    private _dialog: MatDialog) {
  }

  async ngOnInit(): Promise<void> {
    this.siteComplianceCheckFormGroup = this.initSiteComplianceCheckForm();
    var processFlow = await this._closedownService.getProcessFlow();
    if (processFlow.resource &&  processFlow.resource != '' && processFlow.token) {
        this.fastLinkResourceId = processFlow.resource;
    } 
    this._configurationService.getProfileInductionRequired()
      .then(inductionRequirementValue => {
        this.profileInductionRequired = inductionRequirementValue;
      });

    this._configurationService.getProfileRapidGlobalRequired()
      .then(rapidglobalrequired => {
        this.profileRapidGlobalRequired = rapidglobalrequired;
      });

    this._siteService.getSignedInSite().then(site => {
      if (site?.brand?.id) {
        const brandId = site.brand.id;
        this._userService.getBrandInductionConfigs().subscribe({
          next: configs => {
            this.hasActiveBrandInductionConfig = !!(configs && configs.some(
              c => c.brand?.isActive && c.brand?.id === brandId));
          }
        });
      }
    });

    this._authService.getUserRoles().then(
      r => {
        const cityFMRoles = r.filter(s => s == this.defaultCityFMCompanyName || s == this.defaultCityFMAsiaCompanyName);
        if(cityFMRoles && cityFMRoles.length > 0){
          this.defaultCompanyName = cityFMRoles[0];
        }
      }).finally(() =>{
        this.loadSite();
        this.loadUser(true);
      });
      
  }

  private initSiteComplianceCheckForm(): UntypedFormGroup {
    const siteComplianceCheckGroup = this.formBuilder.group({
    });

    return siteComplianceCheckGroup;
  }

  loadUser(refreshInductions?: boolean){
    this._authService.getUser().then(
      user => {
        this.currentUser = user;
        this.fullname = `${user.firstName} ${user.lastName}`;
        this.phoneNumber = user.mobileNumber;
        this.getProfileImageLink(user.photo);
        this.siteInductionInfoList = this.currentUser.siteInductionInfos;
        this.siteInductionInfo = this.siteInductionInfoList.filter(sii => sii.brandId === this.currentSite?.brand?.id);
        if (this.siteInductionInfo.length == 1) {
          this.selectedSiteInductionInfo = this.siteInductionInfo[0];
        }
        else {
          this.selectedSiteInductionInfo = undefined;
        }
        this.rapidGlobalInfoList = this.currentUser.rapidGlobalInfos.map(info => ({ ...info, jobCount: 0 }));
        if (this.currentUser?.withJob) {
            this.populateRapidGlobalInfoWithJobCount();
        }
        else {
            this.populateRapidGlobalInfo();
        }

        if (refreshInductions) {
          this.refreshInductionsFromApi();
        }
      },
      error => {
        console.log("getUser : Failed to get user");
      });
  }

  addOrEditInduction(): void {
    const isEditMode = this.selectedSiteInductionInfo?.inductionId != null
      && this.selectedSiteInductionInfo?.inductionId != undefined;

    const dialogConfig = {
      data: {
        user: this.currentUser,
        induction: isEditMode ? this.selectedSiteInductionInfo : undefined,
        isEditMode
      },
      disableClose: true,
      autoFocus: false,
      panelClass: 'details-container'
    };

    const dialogRef = this._dialog.open(SiteInductionAddEditComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((returnValue) => {
      if (returnValue) {
        this._authService.setUser(returnValue);
        this.currentUser = returnValue;
        this.refreshSiteInductionSelection();
      }
    });
  }

  refreshInductionsFromApi(): void {
    if (!this.currentUser?.siteInductionInfos || this.currentUser.siteInductionInfos.length === 0)
      return;

    const currentUser = this.currentUser;
    const pending = currentUser.siteInductionInfos.filter(i => !!i.inductionId);
    if (pending.length === 0)
      return;

    let completed = 0;

    pending.forEach(info => {
      this._userService.validateInduction(info.brandId, info.inductionId).subscribe({
        next: (result) => {
          if (result.success && result.siteInduction) {
            const idx = currentUser.siteInductionInfos.findIndex(
              s => s.brandId === info.brandId);
            if (idx >= 0) {
              currentUser.siteInductionInfos[idx] = result.siteInduction;
            }
          }
        },
        error: () => {
        },
        complete: () => {
          completed++;
          if (completed >= pending.length) {
            this._authService.setUser(currentUser);
            this.refreshSiteInductionSelection();
          }
        }
      });
    });
  }

  private refreshSiteInductionSelection(): void {
    this.siteInductionInfoList = this.currentUser?.siteInductionInfos || [];
    this.siteInductionInfo = this.siteInductionInfoList.filter(sii => sii.brandId === this.currentSite?.brand?.id);
    this.selectedSiteInductionInfo = this.siteInductionInfo.length === 1 ? this.siteInductionInfo[0] : undefined;
  }

  populateRapidGlobalInfo() {
      if (this.inductionConfigDetail) {
        this.siteComplianceCheckConfig = this.inductionConfigDetail;
      }
   
      if (this.siteComplianceCheckConfig?.answer) {
        this.selectedRapidGlobalId = this.getComplianceCheckAnswerRapidGlobalId();
      }
      else {
        if (this.rapidGlobalInfoList.length > 0) {
          if (this.fastLinkResourceId && this.fastLinkResourceId != '') {
            const companyInfo = this.currentUser?.companies.find(c => c.referenceNumber == this.fastLinkResourceId);
            if (companyInfo) {
              const rapidInfo = this.rapidGlobalInfoList.find(rgi => rgi.companyId === companyInfo.id);
              if (rapidInfo) {
                this.selectedRapidGlobalId = rapidInfo.id;
              }
            }
          }
          if (!this.selectedRapidGlobalId || this.selectedRapidGlobalId === '') {
            this.selectedRapidGlobalId = this.rapidGlobalInfoList[0].id;
          }
        }
      }

      this.selectedRapidGlobalInfo = this.rapidGlobalInfoList.find(rgi => rgi.id === this.selectedRapidGlobalId);

      if (!this.siteComplianceCheckConfig?.answer) {
        this.siteComplianceCheckConfig!.answer = this.getComplianceCheckAnswer();
      }

      if (this.invalidJobCountForCompany()) {
        return;
      }

      if (this.selectedRapidGlobalInfo) {
         if (this.selectedRapidGlobalInfo.companyId) {
          this.validateCityComplianceByCompanyId(this.selectedRapidGlobalInfo.companyId!);
         }
         else {
          if (this.siteComplianceCheckConfig) {
            this.siteComplianceCheckConfig.answer = this.getComplianceCheckAnswer();
          }
        }
      }

      this._closedownService.removeProcessFlow();
  }

  populateRapidGlobalInfoWithJobCount() {
    if (this.currentSite && this.currentUser && this.currentUser.companies && this.currentUser.companies.length > 0) {
      this._jobService.getJobsByCompanyRefNumber(this.currentSite.id).subscribe({
        next: jobs => {
          if (jobs) {
            this.rapidGlobalInfoList.forEach(rgi => {
              let jobCount = 0;
              if (rgi.companyId) {
                const company = this.currentUser?.companies.find(c => c.id === rgi.companyId);
                if (company) {
                  if (company.companyType.toUpperCase() === CompanyType.SUBCON) {
                    jobCount = jobs.filter(job => job.allocatedReferenceId === company.referenceNumber).length;
                  }
                  else {
                    jobCount = jobs.filter(job => job.companyReferenceNumber === company.referenceNumber).length;
                  }
                }
              }
              rgi.jobCount = jobCount;
            });
            this.populateRapidGlobalInfo();    
          }
        },                
        error: e => {
          if (e.error && e.error.errorCode) {
            alert(this._localizationService.translate(e.error.errorCode));
          }
          else {
            alert(this._localizationService.translate("reasonforvisit_error_get_job"));
          }
        },
      });
    }
    
  }
  
  loadSite() {
    this._siteService.getSignedInSite().then(site => {
      if (site) {
        this.currentSite = site;
      } else {
        this._siteService.removeSignedInSite();
        this._router.navigate(['signin']);
      }
    },
      error => {
        alert("Failed to get site info.");
        this._siteService.removeSignedInSite();
        this._router.navigate(['signin']);
      });
  }

  getComplianceCheckAnswer(): string {
    var answer = new ComplianceCheckAnswerModel();
    answer.companyName = this.selectedRapidGlobalInfo?.companyName == null || this.selectedRapidGlobalInfo?.companyName == undefined ? this.defaultCompanyName : this.selectedRapidGlobalInfo?.companyName;
    answer.inductionNo = this.selectedSiteInductionInfo?.inductionId == null || this.selectedSiteInductionInfo?.inductionId == undefined ? "" : this.selectedSiteInductionInfo?.inductionId;
    answer.inductionGuid = this.selectedSiteInductionInfo?.id == null || this.selectedSiteInductionInfo?.id == undefined ? "" : this.selectedSiteInductionInfo?.id

    answer.rapidGlobalId = this.selectedRapidGlobalInfo?.cityComplianceId == null || this.selectedRapidGlobalInfo?.cityComplianceId == undefined ? "" : this.selectedRapidGlobalInfo?.cityComplianceId;
    answer.rapidGlobalGuid = this.selectedRapidGlobalInfo?.id == null || this.selectedRapidGlobalInfo?.id == undefined ? "" : this.selectedRapidGlobalInfo?.id
    answer.companyId = this.selectedRapidGlobalInfo?.companyId == null || this.selectedRapidGlobalInfo?.companyId == undefined ? "" : this.selectedRapidGlobalInfo?.companyId;
    answer.statusId = this.selectedRapidGlobalInfo?.statusId == null || this.selectedRapidGlobalInfo?.statusId == undefined ? -1 : this.selectedRapidGlobalInfo?.statusId;
    
    if(answer.companyName == this.defaultCityFMCompanyName || answer.companyName == this.defaultCityFMAsiaCompanyName){
      answer.statusId = CityComplianceStatus.COMPLIANT;
    }else if(this.checkIfComplianceShouldDisplayNotEnable()){
      answer.statusId = CityComplianceStatus.NOTAPPLICABLE;
    }
    
    return JSON.stringify(answer);
  }

  checkIfComplianceShouldDisplayNotEnable(){
    if (this.defaultCompanyName == this.defaultCityFMCompanyName || this.defaultCompanyName == this.defaultCityFMAsiaCompanyName) {
      return false;
    } else if(this.selectedRapidGlobalInfo?.companyName == this.defaultNoCompanySpecified){
      return true;
    }else if(this.selectedRapidGlobalInfo && this.selectedRapidGlobalInfo.status == ""){
      return true;
    }

    return false;
  }

  getComplianceCheckAnswerRapidGlobalId(): string {
    if (this.siteComplianceCheckConfig?.answer) {
      var model = JSON.parse(this.siteComplianceCheckConfig?.answer) as ComplianceCheckAnswerModel;
      return model.rapidGlobalGuid;
    }
    return "";
  }

  selectCompany(selectedRapidGlobalId: string) {
    this.selectedRapidGlobalId = selectedRapidGlobalId;
    this.selectedRapidGlobalInfo = this.rapidGlobalInfoList.find(rgi => rgi.id === this.selectedRapidGlobalId);
    if (this.siteComplianceCheckConfig) {
      this.siteComplianceCheckConfig.answer = this.getComplianceCheckAnswer();
    }
    if (this.invalidJobCountForCompany()) {
      return;
    }

    if (this.selectedRapidGlobalInfo?.companyId) {
        this.validateCityComplianceByCompanyId(this.selectedRapidGlobalInfo.companyId!);
    }
    
    if(this.selectedRapidGlobalInfo != undefined && this.selectedRapidGlobalInfo.companyId == null){
      // complianceErrorMessage needs to be cleared if company added from User Profile is selected because validateCityCompliance() will not be called
      this.complianceErrorMessage = '';
    }
  }

  private validateCityComplianceByCompanyId(companyId: string): void {
    this.complianceErrorMessage = "";
    const company = this.currentUser?.companies.find(c => c.id === companyId);
    if (company && company.companyType.toUpperCase() === CompanyType.SUBCON) {
       this.outputCityCompliance.errorMessage = '';
       this.selectedRapidGlobalInfo!.companyId = companyId;
       this.outputCityCompliance.cityComplianceStatus = CityComplianceStatus.NOTAPPLICABLE;
       this.selectedRapidGlobalInfo!.status = this.statusNotApplicable;
       this.selectedRapidGlobalInfo!.statusId = CityComplianceStatus.NOTAPPLICABLE;
       this.showComplianceError.emit(this.outputCityCompliance);
       if (this.siteComplianceCheckConfig) {
         this.siteComplianceCheckConfig.answer = this.getComplianceCheckAnswer();
       }
    }
    else {
      if (this.currentSite) {
        this._userService.validateCityComplianceByCompanyId(companyId, this.currentSite.id).subscribe({
          next: (s) => {
            if (this.selectedRapidGlobalInfo) {
              this.outputCityCompliance.errorMessage = '';
              this.selectedRapidGlobalInfo!.companyId = companyId;
              this.selectedRapidGlobalInfo!.cityComplianceId = s.resourceId;
              this.outputCityCompliance.siteId = this.currentSite?.id || '';
              if(s.cityComplianceStatus)
                this.selectedRapidGlobalInfo.statusId = s.cityComplianceStatus;

              switch (s.cityComplianceStatus) {
                case CityComplianceStatus.COMPLIANT:
                  this.selectedRapidGlobalInfo!.status = this.statusCompliant;
                  this.outputCityCompliance.cityComplianceStatus = CityComplianceStatus.COMPLIANT;
                  break;
                case CityComplianceStatus.NOTCOMPLIANT:
                  this.outputCityCompliance.cityComplianceStatus = CityComplianceStatus.NOTCOMPLIANT;
                  this.selectedRapidGlobalInfo!.status = this.statusNotCompliant;
                  break;
                case CityComplianceStatus.NOTAPPLICABLE:
                  this.outputCityCompliance.cityComplianceStatus = CityComplianceStatus.NOTAPPLICABLE;
                  this.selectedRapidGlobalInfo!.status = this.statusNotApplicable;
                  break;
                default:
              }
              this.showComplianceError.emit(this.outputCityCompliance);
              this.complianceErrorMessage = s.errorMessage;

            }
            if (this.siteComplianceCheckConfig) {
              this.siteComplianceCheckConfig.answer = this.getComplianceCheckAnswer();
            }
          },
          error: (error) => {
            if (error.error && error.error.errorCode) {
              alert(this._localizationService.translate(error.error.errorCode));
            }
            else {
              alert(this._localizationService.translate('site_compliance_compliance_status_error'));
            }
          }
        });
      } else {
        alert(this._localizationService.translate("site_compliance_compliance_status_error"));
      }
    }
   
  }

  private getProfileImageLink(userPhoto: string) {
    if (environment.isDemo) {
      this.profileImgLink = userPhoto;
    } else {
      // Regular expression to check if string is a valid UUID
      const regexExp = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi;

      if (!regexExp.test(userPhoto)) {
        this.profileImgLink = userPhoto;
      } else {
        if (this.currentUser) {
          this._fileStorageService.download(userPhoto).subscribe(
            {
              next: file => {
                this.profileImgLink = `data:image/${file.fileType};base64,${file.file}`;
                if (this.currentUser) {
                  this.currentUser.photo = this.profileImgLink;
                  this._authService.setUser(this.currentUser);
                }

              },
              error: error => {
                if (error.error && error.error.errorCode) {
                  alert(this._localizationService.translate(error.error.errorCode));
                }
                else {
                  alert(this._localizationService.translate("site_compliance_check_error_downloading_photo"));
                }
                this.profileImgLink = "";
              }
            });
        } else {
          this.profileImgLink = "";
        }
      }
    }
  }
 
  public invalidJobCountForCompany(): boolean {
    if (this.currentUser) {
      if (this.currentUser.withJob) {
        if (this.selectedRapidGlobalId && this.rapidGlobalInfoList && this.rapidGlobalInfoList.length > 0) {
           this.selectedRapidGlobalInfo = this.rapidGlobalInfoList.find(rgi => rgi.id === this.selectedRapidGlobalId);
           if(this.selectedRapidGlobalInfo && this.selectedRapidGlobalInfo.jobCount <= 0) {
             this.outputCityCompliance.errorMessage = this._localizationService.translate('site_compliance_check_error_no_job_for_company');
             this.showComplianceError.emit(this.outputCityCompliance);
             return true;
           }
           else {
             this.outputCityCompliance.errorMessage = "";
             this.showComplianceError.emit(this.outputCityCompliance);
             return false;
           }
        }
      }
    }
    return false;
  }
}
